import { AgmInfoWindow } from '@agm/core';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../config/config';
import { AddEventBriteGeneralFeedCommand } from '../../../commands/hub/event/add.eventbrite.general.feed.command';
import {
    HubFacebookFeedsCommand
} from '../../../commands/hub/event/add.facebook.general.feed.command';
import { AddFacebookLocationFeedCommand } from '../../../commands/hub/event/add.facebook.location.feed.command';
import { ButtonTriggerEvent } from '../../../common/components';
import { AddressInputComponent } from '../../../common/components/address.input/address.input.component';
import { BaseComponent } from '../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../common/services/modal.service';
import { HubFeed } from '../../../models/hub/hub.feed';
import { ConfigService } from '../../../services/config.service';
import { HubApiService } from '../../../services/hub.api.service';
import { HubFacebookLocationFeedsStore, HubFacebookPageFeedsStore } from '../../../stores/hub.calendar.store';
import { EventLocationAdding } from '../edit.account/event.add.location';
import { EventPageAdding } from '../edit.account/event.add.page';
import { HubComponent } from '../hub.component';

@Component({
    selector: 'ig-event-brite-add',
    templateUrl: './event.brite.add.component.html',
    styleUrls: ['./event.brite.add.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class EventBriteAddComponent extends BaseComponent implements OnInit {
    public hubName: string;
    public eventLocation = new EventLocationAdding();
    public eventFormGroup: FormGroup;
    public eventPage = new EventPageAdding();
    public locationFormGroup: FormGroup;
    public zoom = ConfigService.config.google.fullUSMapZoom;
    public isShowMarker = false;
    public isFeedExisted = false;
    public inAddingLocationFeed = false;
    public showSuccessInfo = false;
    public autoCompletedAddress: any;
    public mileToMeters = config.mileToMeters;
    @ViewChild('infoWindow') infoWindow: AgmInfoWindow;
    @ViewChild('addressInput') addressInput: AddressInputComponent;
    public hubPages: HubFeed[];
    public hubLocations: HubFeed[];

    constructor(private router: Router,
                private formBuilder: FormBuilder,
                private hubApiService: HubApiService,
                private activatedRoute: ActivatedRoute,
                private modalService: ModalService,
                private parent: HubComponent,
                private hubFacebookFeedsStore: HubFacebookPageFeedsStore,
                private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore) {
        super({activatedRoute});
    }

    public ngOnInit(): void {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;

        this.eventFormGroup = this.formBuilder.group({
            'facebookPageUrlOrName': [null, [Validators.required]],
            'displayTitle': [null, null],
            'tags': [null, null]
        });

        this.locationFormGroup = this.formBuilder.group({
            'address': [null, [Validators.required]],
            'displayTitle': [null, null],
            'tags': [null, null],
            'radius': [null, [Validators.required]]
        });

        this.hubFacebookFeedsStore.pagesCommand
            .takeUntil(this.isDestroyed)
            .subscribe((hubPages: HubFacebookFeedsCommand) => {
                this.hubPages = hubPages.hubPages ?
                    hubPages.hubPages.filter(x => x.socialName == config.eventbrite)
                    : undefined;
            });

        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe((hubLocations: HubFacebookFeedsCommand) => {
                this.hubLocations = hubLocations.hubPages ?
                    hubLocations.hubPages.filter(x => x.socialName == config.eventbrite)
                    : undefined;
            });
    }

    public addEventBriteOrganizer(event: ButtonTriggerEvent) {
        let organizer = this.GetOrganizerInfo(this.eventPage.facebookPageUrlOrName);
        if (!organizer) {
            return;
        }

        this.hubApiService.addEventbriteOrganizerFeed(this.hubName, new AddEventBriteGeneralFeedCommand(
            organizer.organizerID,
            this.eventPage.displayTitle ? this.eventPage.displayTitle : organizer.name,
            this.eventPage.tags,
            this.hubName
        )).finally(event.complete)
            .subscribe(result => {
                let data = <ConfirmModalData>{
                    confirmModalIcon: 'done',
                    confirmModalTitle: 'Success',
                    confirmModalDescription: 'Added the events of Eventbrite organizer success',
                    confirmModalCancelButtonText: 'OK',
                    isAsync: true
                };

                if (result && result.error) {
                    data.confirmModalTitle = 'Failed';
                    data.confirmModalIcon = 'warning';
                    if (result.error.code === 100) {
                        data.confirmModalDescription = 'Uh-oh! Check your Eventbrite organizer settings! ';
                    } else if (result.error.code === 803) {
                        data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
                    }
                } else {
                    this.eventFormGroup.markAsPristine();
                    this.eventPage.displayTitle = null;
                    this.eventPage.facebookPageUrlOrName = null;

                    this.hubApiService.getPageFeeds(this.hubName).subscribe(data => {
                        let pageCommand = new HubFacebookFeedsCommand(data);
                        this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
                    });
                }

                let actions = <ConfirmModalActions>{};

                this.modalService.show({
                    component: ConfirmModalComponent,
                    providers: [
                        {provide: ConfirmModalActions, useValue: actions},
                        {provide: ConfirmModalData, useValue: data}
                    ]
                });
            });
    }

    public addLocation(event: ButtonTriggerEvent) {
        this.inAddingLocationFeed = true;
        this.showSuccessInfo = false;

        if (this.isFeedExisted) {
            this.hubApiService.removeLocationFeed(this.hubName, this.eventLocation.feedId, 'eventbrite')
                .finally(() => {
                    event.complete();
                    this.inAddingLocationFeed = false;
                }).subscribe(() => {
                this.locationFormGroup.markAsPristine();
                this.showSuccessInfo = true;

                setTimeout(() => {
                    this.showSuccessInfo = false;
                    this.infoWindow.close();
                    this.addressInput.clear();

                    this.getHubLocations();
                }, 1500);
            });
            return;
        }

        // let points = GoogleMapsService.getPoints(this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius);
        // console.log(points);

        this.hubApiService.addEventBriteLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address,
            this.hubName,
            null,
            null,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.tags,
            config.eventbrite
        )).finally(() => {
            event.complete();
            this.inAddingLocationFeed = false;
        }).subscribe(() => {
            this.locationFormGroup.markAsPristine();
            this.showSuccessInfo = true;
            this.getHubLocations();
        });
    }

    private getHubLocations() {
        this.hubApiService.getLocationFeeds(this.hubName).subscribe(data => {
            this.hubLocations = data;
            this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(this.hubLocations));
        });
    }

    private GetOrganizerInfo(url: string): any {
        if (!url) {
            return null;
        }
        if (url.startsWith('https://www.eventbrite.com/o/')) {
            let organizer = url.split('?')[0].split('.com/o/')[1].split('/')[0].split('-');
            if (organizer.length > 1) {
                let id = organizer.splice(organizer.length - 1, 1);
                return {
                    organizerID: id[0],
                    name: organizer.join(' ')
                };
            }
        }

        this.modalService.showErrorModal('Please enter a valid eventbrite organizer url!');
        return null;
    }

    public findOnMap() {
        if (this.autoCompletedAddress) {
            this.showSuccessInfo = false;
            this.eventLocation.lat = this.autoCompletedAddress.lat;
            this.eventLocation.lng = this.autoCompletedAddress.lng;
            this.zoom = ConfigService.config.google.locationMapZoom;
            this.isShowMarker = true;

            this.getLocationStatus();
        } else {
            this.resetMap();
        }
    }

    private getLocationStatus() {
        this.hubApiService.getLocationStatus(
            this.hubName, this.autoCompletedAddress.lat, this.autoCompletedAddress.lng, 'eventbrite')
            .subscribe((result) => {
                if (result) {
                    this.isFeedExisted = result.connected;
                    if (this.isFeedExisted) {
                        this.eventLocation.displayTitle = result.title;
                    } else {
                        this.eventLocation.displayTitle = this.autoCompletedAddress.address;
                    }
                    if (result.radius) {
                        this.eventLocation.radius = result.radius / config.mileToMeters;
                    }
                    this.eventLocation.feedId = result.feedId;
                }
            });
    }

    deleteLocationFeed(location: HubFeed) {
        let actions = <ConfirmModalActions>{
            confirm: (feed: ButtonTriggerEvent) => {
                this.hubApiService.removeLocationFeed(this.hubName, location.id, 'eventbrite')
                    .finally(feed.complete)
                    .subscribe(() => {
                        this.getHubLocations();
                    });
            }
        };

        let data = <ConfirmModalData>{
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this Location?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };

        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                {provide: ConfirmModalActions, useValue: actions},
                {provide: ConfirmModalData, useValue: data}
            ]
        });
    }

    deleteEventFeed(page: HubFeed) {
        let actions = <ConfirmModalActions>{
            confirm: (feed: ButtonTriggerEvent) => {
                this.hubApiService.removePageFeed(this.hubName, page.id)
                    .finally(feed.complete)
                    .subscribe(() => {
                        this.hubApiService.getPageFeeds(this.hubName).subscribe(data => {
                            let pageCommand = new HubFacebookFeedsCommand(data);
                            this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
                        });
                    });
            }
        };

        let data = <ConfirmModalData>{
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this page?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };

        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                {provide: ConfirmModalActions, useValue: actions},
                {provide: ConfirmModalData, useValue: data}
            ]
        });
    }

    private resetMap() {
        this.eventLocation.lat = ConfigService.config.google.USCenter.lat;
        this.eventLocation.lng = ConfigService.config.google.USCenter.lng;
        this.isShowMarker = false;
        this.zoom = ConfigService.config.google.fullUSMapZoom;
    }
}




// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.eventbrite/event.brite.add.component.ts